import TextField from "@mui/material/TextField";
import {Autocomplete, Grid} from "@mui/material";
import {CollectionNode, Node} from "../../types";


interface Props {
    marqueCollections: Node[],
    selectedMarqueCollection?: Node,
    setSelectedMarqueCollection: Function,
    selectedCollection?: CollectionNode,
    setSelectedCollection: Function,
    children?: any
}

export const MarqueCollectionSelection = ({
    marqueCollections, selectedMarqueCollection, selectedCollection,
    setSelectedCollection, setSelectedMarqueCollection, children
} : Props) => {

    const getCollections = () => {
        if (selectedMarqueCollection) {
            return selectedMarqueCollection.children ?? []
        } else {
            return []
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid>
                <Autocomplete
                    style={{width: 270}}
                    options={marqueCollections}
                    getOptionLabel={(option: { label: string; }) => option.label}
                    value={selectedMarqueCollection || null}
                    onChange={(event: any, newValue) => {
                        setSelectedMarqueCollection(newValue);
                        setSelectedCollection(null);
                    }}
                    renderInput={(params: any) => <TextField {...params} label="Marque"
                                                        variant="outlined"/>}
                />
            </Grid>
            <Grid>
                <Autocomplete
                    style={{width: 270}}
                    options={getCollections()}
                    getOptionLabel={(option: { label: any; }) => option.label}
                    value={selectedCollection || null}
                    onChange={(event, newValue) => {
                        setSelectedCollection(newValue);
                    }}
                    renderInput={(params: any) => <TextField error={false} {...params} label="Collection"
                                                        variant="outlined"/>}
                />
            </Grid>
            {children &&
            <Grid>{children}</Grid>}
        </Grid>
    )
}
